import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/_access/users/')({
  component: () => null,
});
